import { cx } from '@emotion/css';
import type { FC } from 'react';

import { Icon } from '../Icon';
import { navigationButtonContainerCss } from './styles';
import type { NavigationButtonProps } from './types';

export const NavigationButtonLeft: FC<NavigationButtonProps> = ({
  onClick,
  isDisabled = false,
  label,
  showArrow = true,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={isDisabled}
      className={cx(navigationButtonContainerCss, className)}
    >
      {showArrow && (
        <i>
          <Icon name="arrow-left" />
        </i>
      )}
      {label}
    </button>
  );
};

NavigationButtonLeft.displayName = 'NavigationButtonLeft';
